
import { fabric } from "fabric-with-erasing";
import { controlsInit } from "./fabricControls";
import { EventBus } from './eventBus.js';
import Vue from 'vue'
import Gio from "@/utils/gio";
import lodash from "lodash";

const colorArr = ["#4B59F8", "#5B8FF4", "#349957", "#73CC5E", "#AEE377", "#FE9949", "#FEDA46", "#8C8C8C", "#DFDFDF", "#534D5F"]
const widthArr = [
    {
        width: 4,
        lineWidth: 3
    },
    {
        width: 8,
        lineWidth: 4
    },
    {
        width: 14,
        lineWidth: 5
    },
    {
        width: 20,
        lineWidth: 6
    }
]

const DrawType = {
    ADD: 'ADD',
    ADD_TEMPLATE: 'ADD_TEMPLATE',
    MODIFY: 'MODIFY',
    ERASE: 'ERASE',
    REMOVED: 'REMOVED',
    MIRROR: 'MIRROR'
}

export class CanvasDraw {
    canvas = null;
    iconIndex = -1;
    oldIconPosition = null;
    history = []
    oldHistory = []
    widthArr = widthArr
    colorArr = colorArr
    activeColor = colorArr[0]
    lineWidth = widthArr[0].width;
    eraseWidth = widthArr[0].width;
    strokeWidth = widthArr[0].width;
    fontSize = 18
    drawingObject = null
    textObject = null
    mouseFrom = {}
    mouseTo = {}
    currentType = "free";
    isDrawing = false
    changeIconActiveData = null
    undoDisabled = true
    redoDisabled = true
    menuActive = 1
    addDraw = true
    saveNum = 10
    undoHistory = []
    redoHistory = []
    templateObj = null
    isUndoRedoing = false
    addLoad = false
    initialVal = null
    isErasing = false
    constructor(canvas) {
        this.canvas = new fabric.Canvas(canvas, {
            antialias: false
        });
        this.canvas.minScaleLimit = 1
        this.initfreeDraw();
        this.initEvent();
        this.initHistoryEvent();
    }

    initHistoryEvent() {
        this.canvas.on(
            'object:modified', (object) => {
                console.log('object:modified', object);
                this.undoHistory.push({ type: DrawType.MODIFY, data: this.cloneTemplateObj(object.target), templateObj: object.target, iconIndex: this.iconIndex });
                this.redoHistory = []
            }
        );
        // 
        this.canvas.on(
            'mouse:down:before', (object) => {
                console.log('mouse:down:before', object, this.currentType);
                if (this.currentType === "eraser") {
                    this.initialVal = this.getPixel();
                }
            }
        );
        this.canvas.on(
            'object:added', (object) => {
                console.log('object:added', object);
                if (this.isUndoRedoing) {
                    console.log('object:added return isUndoRedoing is true')
                    return
                }
                if (!object.target.erasable) {
                    this.undoHistory.push({
                        type: DrawType.ADD_TEMPLATE, data: this.cloneTemplateObj(object.target),
                        templateObj: object.target, templateIndex: this.canvas.getObjects().length - 1, iconIndex: this.iconIndex
                    });
                } else {
                    this.undoHistory.push({ type: DrawType.ADD, data: object.target });
                }
                this.redoHistory = []
            }
        );
        this.canvas.on(
            'erasing:end', (object) => {
                console.log('erasing:end', object)
                this.isErasing = true
                var resultVal = this.getPixel();
                if (object.targets.length > 0 && this.getPixelchange(this.initialVal, resultVal)) {
                    console.log('erasing:end-push', object)
                    this.undoHistory.push({ type: DrawType.ERASE, data: object });
                    this.redoHistory = []
                } else if (object.targets.length > 0) {
                    object.targets.forEach(item => {
                        item.eraser._objects.pop()
                    })
                }
            }
        );

        this.canvas.on('object:moving', (e) => {
            var obj = e.target;
            const zoom = this.canvas.getZoom();
            const canvasWidth = this.canvas.width / zoom;
            const canvasHeight = this.canvas.height / zoom;

            let padding = 30
            // console.log('object:moving', padding)
            if (obj.left < padding) {
                obj.left = padding;
            } else if (obj.left > canvasWidth - padding) {
                obj.left = canvasWidth - padding
            }

            if (obj.top < padding) {
                obj.top = padding;
            } else if (obj.top > canvasHeight - padding) {
                obj.top = canvasHeight - padding
            }

            obj.setCoords();
            this.canvas.renderAll();
        });

        // 限制缩放不能超过画布
        // this.canvas.on('object:scaling', (event) => {
        //     console.log('object:scaling', event)
        //     const obj = event.target;
        //     const canvasWidth = this.canvas.width;
        //     const canvasHeight = this.canvas.height;
        //     console.log('object:scaling', canvasWidth, canvasHeight, canvasWidth / canvasHeight)
        //     // 计算新的宽度和高度
        //     const newHeight = event.target.height * obj.scaleX 
        //     const newWidth = event.target.width * obj.scaleX


        //     // // 检查是否超出边界
        //     if (canvasWidth / canvasHeight > 1) {
        //         if (newHeight > canvasHeight) {
        //             // 设置宽高
        //             obj.scaleX = obj.scaleY = canvasHeight / obj.height;
        //         }
        //     } else {
        //         if (newWidth > canvasWidth) {
        //             // 设置宽高
        //             obj.scaleX = obj.scaleY = canvasWidth  / obj.width;
        //         }
        //     }


        //     obj.setCoords(); // 更新坐标
        //     this.canvas.renderAll(); // 重新绘制
        // });

    }

    getPixel() {
        const canvas = document.getElementById('myCanvas')
        const imageData = canvas.getContext('2d')
            .getImageData(0, 0, canvas.width, canvas.height);
        return imageData.data
    }

    getPixelchange(initial, result) {
        let ischange = false;
        for (let i = 0; i < initial.length; i++) {
            if (initial[i] > result[i] + 2 || initial[i] < result[i] - 2) {
                console.log('getPixelchange', initial[i], result[i])
                ischange = true
                break;
            }
        }
        return ischange
    }

    cloneTemplateObj(object) {
        return lodash.pick(object, ['top', 'left', 'width', 'height', 'scaleX', 'scaleY', 'aCoords', 'lineCoords', 'oCoords', 'angle'])
    }

    undoDraw() {
        if (this.undoHistory.length > 0) {
            let undoObj = this.undoHistory[this.undoHistory.length - 1]
            // console.log('undo start undoObj: ', undoObj.type, this.undoHistory, this.redoHistory, this.canvas._objects)
            var lastAddTemplate = null
            if (undoObj.type == DrawType.ADD) {
                this.canvas.remove(undoObj.data)
                this.canvas.renderAll()
                this.redoHistory.push(this.undoHistory.pop())
            } else if (undoObj.type == DrawType.ADD_TEMPLATE) {
                this.isUndoRedoing = true
                this.canvas.remove(undoObj.templateObj)
                let lastAddTemplateindex = -1
                for (let i = this.undoHistory.length - 2; i >= 0; i--) {
                    if (this.undoHistory[i]?.type == DrawType.ADD_TEMPLATE) {
                        lastAddTemplateindex = this.undoHistory[i].templateIndex
                        lastAddTemplate = this.undoHistory[i]
                        break;
                    }
                }
                if (lastAddTemplateindex != -1) {
                    for (let i = this.undoHistory.length - 2; i >= 0; i--) {
                        if (this.undoHistory[i]?.type == DrawType.REMOVED) {
                            lastAddTemplate = null
                            break;
                        } else if (this.undoHistory[i]?.type == DrawType.ADD_TEMPLATE
                            || this.undoHistory[i]?.type == DrawType.MIRROR
                            || this.undoHistory[i]?.type == DrawType.MODIFY) {
                            this.canvas.insertAt(this.undoHistory[i].templateObj, lastAddTemplateindex)
                            break;
                        }
                    }
                }

                this.canvas.renderAll()
                this.redoHistory.push(this.undoHistory.pop())

                this.isUndoRedoing = false

            } else if (undoObj.type == DrawType.MODIFY) {

                let prevTemplateObj
                    ;
                for (let i = this.undoHistory.length - 2; i >= 0; i--) {
                    // console.log('this.undoHistory[i]: ', this.undoHistory[i])
                    prevTemplateObj = this.undoHistory[i]?.type == DrawType.MODIFY
                        || this.undoHistory[i]?.type == DrawType.ADD_TEMPLATE
                        || this.undoHistory[i]?.type == DrawType.MIRROR ? this.undoHistory[i]?.data : null
                    if (prevTemplateObj) {
                        break;
                    }
                }
                this.isUndoRedoing = true
                if (prevTemplateObj) {
                    undoObj.templateObj.top = prevTemplateObj.top
                    undoObj.templateObj.left = prevTemplateObj.left
                    undoObj.templateObj.width = prevTemplateObj.width
                    undoObj.templateObj.height = prevTemplateObj.height
                    undoObj.templateObj.scaleX = prevTemplateObj.scaleX
                    undoObj.templateObj.scaleY = prevTemplateObj.scaleY
                    undoObj.templateObj.aCoords = prevTemplateObj.aCoords
                    undoObj.templateObj.lineCoords = prevTemplateObj.lineCoords
                    undoObj.templateObj.oCoords = prevTemplateObj.oCoords
                    undoObj.templateObj.angle = prevTemplateObj.angle
                    undoObj.templateObj.dirty = true
                }
                this.canvas.renderAll()
                this.redoHistory.push(this.undoHistory.pop())
                this.isUndoRedoing = false

            } else if (undoObj.type == DrawType.REMOVED) {
                this.isUndoRedoing = true
                let prevAddTemplateIndex
                    ;
                for (let i = this.undoHistory.length - 2; i >= 0; i--) {
                    if (this.undoHistory[i]?.type == DrawType.ADD_TEMPLATE) {
                        prevAddTemplateIndex = this.undoHistory[i]?.templateIndex
                        break;
                    }
                }
                this.canvas.insertAt(undoObj.templateObj, prevAddTemplateIndex)
                this.canvas.renderAll()
                this.redoHistory.push(this.undoHistory.pop())
                this.isUndoRedoing = false

            } else if (undoObj.type == DrawType.MIRROR) {
                undoObj.templateObj.flipX = !undoObj.templateObj.flipX
                undoObj.templateObj.dirty = true
                this.canvas.renderAll()
                this.redoHistory.push(this.undoHistory.pop())

            } else {
                // 橡皮檫动作undo
                let eraserPathList = []
                undoObj.eraserPathList = eraserPathList
                undoObj.data.targets?.forEach(item => {
                    eraserPathList.push(item.eraser._objects?.pop())
                    item.dirty = true
                    item.eraser.dirty = true
                })
                this.canvas.renderAll()
                this.redoHistory.push(this.undoHistory.pop())
            }

            // console.log('undo finish undoHistory: ', this.redoHistory)

            if (undoObj.type == DrawType.REMOVED || undoObj.type == DrawType.MODIFY || undoObj.type == DrawType.MIRROR) {
                this.iconIndex = undoObj.iconIndex;
                EventBus.$emit('changeIconActive', this.iconIndex)
                this.selectDraw()
            } else if (undoObj.type == DrawType.ADD_TEMPLATE) {
                if (lastAddTemplate) {
                    this.iconIndex = lastAddTemplate.iconIndex;
                    this.selectDraw()
                } else {
                    this.iconIndex = -1;
                }

                EventBus.$emit('changeIconActive', this.iconIndex)
            }
            this.history = this.canvas.getObjects();
            Gio.track({
                ClickButton_var: "后退一步"
            })
        }
    }

    redoDraw() {
        if (this.redoHistory.length > 0) {
            let redoObj = this.redoHistory[this.redoHistory.length - 1]

            if (redoObj.type == DrawType.ADD) {
                // this.canvas._objects.push(redoObj.data)
                this.isUndoRedoing = true
                this.canvas.add(redoObj.data);
                this.canvas.renderAll()
                this.undoHistory.push(this.redoHistory.pop())
                this.isUndoRedoing = false
            } else if (redoObj.type == DrawType.ADD_TEMPLATE) {
                this.isUndoRedoing = true
                this.removeModel()
                this.canvas.insertAt(redoObj.templateObj, redoObj.templateIndex)
                this.selectDraw()
                this.canvas.renderAll()
                this.undoHistory.push(this.redoHistory.pop())
                this.isUndoRedoing = false
            } else if (redoObj.type == DrawType.MODIFY) {
                this.isUndoRedoing = true
                redoObj.templateObj.top = redoObj.data.top
                redoObj.templateObj.left = redoObj.data.left
                redoObj.templateObj.width = redoObj.data.width
                redoObj.templateObj.height = redoObj.data.height
                redoObj.templateObj.scaleX = redoObj.data.scaleX
                redoObj.templateObj.scaleY = redoObj.data.scaleY
                redoObj.templateObj.aCoords = redoObj.data.aCoords
                redoObj.templateObj.lineCoords = redoObj.data.lineCoords
                redoObj.templateObj.oCoords = redoObj.data.oCoords
                redoObj.templateObj.angle = redoObj.data.angle
                redoObj.templateObj.dirty = true
                this.canvas.renderAll()
                // console.log('redo DrawType.MODIFY ', this.redoHistory)
                this.undoHistory.push(this.redoHistory.pop())
                this.isUndoRedoing = false
            } else if (redoObj.type == DrawType.REMOVED) {
                this.isUndoRedoing = true
                this.canvas.remove(redoObj.templateObj)
                this.canvas.renderAll()
                this.undoHistory.push(this.redoHistory.pop())
                this.isUndoRedoing = false
                // console.log('redo DrawType.REMOVED ', this.undoHistory)
            } else if (redoObj.type == DrawType.MIRROR) {
                redoObj.templateObj.flipX = !redoObj.templateObj.flipX
                redoObj.templateObj.dirty = true
                this.canvas.renderAll()
                this.undoHistory.push(this.redoHistory.pop())
            } else {
                // 橡皮檫动作redo
                let i = 0;
                redoObj?.data?.targets?.forEach(item => {
                    item.eraser._objects?.push(redoObj.eraserPathList[i++])
                    item.dirty = true
                    item.eraser.dirty = true
                    // console.log('item: ', item)
                })
                this.canvas.renderAll()
                this.undoHistory.push(this.redoHistory.pop())
            }
            // console.log('redo finish undoHistory: ', this.redoHistory)
            if (redoObj.type == DrawType.MIRROR || redoObj.type == DrawType.ADD_TEMPLATE || redoObj.type == DrawType.MODIFY) {
                this.iconIndex = redoObj.iconIndex;
                EventBus.$emit('changeIconActive', this.iconIndex)
            } else if (redoObj.type == DrawType.REMOVED) {
                this.iconIndex = -1;
                EventBus.$emit('changeIconActive', this.iconIndex)
            }
            this.history = this.canvas.getObjects();
            Gio.track({
                ClickButton_var: "前进一步"
            })
        }
    }
    changeIconActive(item, index, cb) {
        if (this.addLoad) return;
        this.addLoad = true
        this.changeIconActiveData = {
            item,
            index
        }
        var history = this.canvas.getObjects()
        // console.log('changeIconActive', history)
        if (!this.history.length) {
            this.deleteIcon();
            return;
        }
        var isModel = true;
        for (var i = 0; i < history.length; i++) {
            if (history[i].type == "image") {
                // console.log('history[i]', history[i], this.oldIconPosition)
                let icon = history[i]
                isModel = false
                if (this.oldIconPosition && icon.top.toFixed(2) == this.oldIconPosition.top
                    && icon.left.toFixed(2) === this.oldIconPosition.left
                    && icon.scaleX.toFixed(2) === this.oldIconPosition.scaleX
                    && icon.scaleY.toFixed(2) === this.oldIconPosition.scaleY
                    && (icon.angle || 0) == this.oldIconPosition.angle
                    && (icon.flipX || false) == this.oldIconPosition.flipX) {
                    this.deleteIcon()
                } else {
                    this.addLoad = false
                    cb(true)
                }
                break;
            }

        }
        if (isModel) this.deleteIcon();
    }

    setCanvasSize(width, height) {
        this.canvas.setWidth(width);
        this.canvas.setHeight(height);
        this.canvas.renderAll();
    }

    setCanvasZoom(zoom) {
        console.log('setCanvasZoom', zoom)
        this.canvas.setZoom(zoom)
        this.canvas.renderAll();
    }

    initfreeDraw() {
        controlsInit(this.canvas, (templateObj) => {
            if (this.isUndoRedoing) {
                console.log('object:removed return isUndoRedoing is true')
                return
            }
            this.templateObj = templateObj
            // console.log('object:removed object', object)
            this.undoHistory.push({ type: DrawType.REMOVED, templateObj: templateObj, iconIndex: this.iconIndex });
            this.redoHistory = []
            this.iconIndex = -1;
            EventBus.$emit('changeIconActive', this.iconIndex)

        }, (isMirror, templateObj) => {
            this.undoHistory.push({ type: DrawType.MIRROR, data: this.cloneTemplateObj(templateObj), templateObj: templateObj, iconIndex: this.iconIndex })
        });

        this.canvas.selection = false;
        this.canvas.backgroundColor = "rgba(0,0,0,0)";
        this.canvas.isDrawingMode = true;
        this.state = JSON.stringify(this.canvas);
        // 启用历史记录跟踪
        this.canvas.trackedControls = {
            redo: true,
            undo: true
        };

        this.canvas.freeDrawingBrush.color = this.activeColor;
        this.canvas.freeDrawingBrush.width = this.lineWidth;
        this.canvas.renderAll();
    }
    initLine() {
        let canvasObject = new fabric.Line(
            [this.mouseFrom.x, this.mouseFrom.y, this.mouseTo.x, this.mouseTo.y],
            {
                fill: this.activeColor,
                stroke: this.activeColor,
                strokeWidth: this.strokeWidth,
                evented: false
            }
        );
        this.toggleDrawingObject(canvasObject);
    }
    initCircle() {
        let left = this.mouseFrom.x;
        let top = this.mouseFrom.y;
        let radius =
            Math.sqrt(
                (this.mouseTo.x - left) * (this.mouseTo.x - left) +
                (this.mouseTo.y - top) * (this.mouseTo.y - top)
            ) / 2;
        let canvasObject = new fabric.Circle({
            left: left,
            top: top,
            stroke: this.activeColor,
            fill: "rgba(255, 255, 255, 0)",
            radius: radius,
            strokeWidth: this.strokeWidth
        });
        this.toggleDrawingObject(canvasObject);
    }
    initRect() {
        let left = this.mouseFrom.x;
        let top = this.mouseFrom.y;
        let width = this.mouseTo.x - this.mouseFrom.x;
        let height = this.mouseTo.y - this.mouseFrom.y;
        let canvasObject = new fabric.Rect({
            left: left,
            top: top,
            width: width,
            height: height,
            stroke: this.activeColor,
            fill: "rgba(255, 255, 255, 0)",
            strokeWidth: this.strokeWidth
        });
        this.toggleDrawingObject(canvasObject);
    }
    initTriangle() {
        let left = this.mouseFrom.x;
        let top = this.mouseFrom.y;
        let height = this.mouseTo.y - this.mouseFrom.y;
        let width = Math.sqrt(Math.pow(height, 2) + Math.pow(height / 2.0, 2));
        let canvasObject = new fabric.Triangle({
            left: left,
            top: top,
            width: width,
            height: height,
            stroke: this.activeColor,
            fill: "rgba(255, 255, 255, 0)",
            strokeWidth: this.strokeWidth
        });
        this.toggleDrawingObject(canvasObject);
    }
    initText() {
        this.canvas.isDrawingMode = false;
        this.canvas.selection = false;
        this.textObject = new fabric.Textbox("", {
            left: this.mouseFrom.x,
            top: this.mouseFrom.y,
            fontSize: this.fontSize,
            fill: this.activeColor,
            hasControls: false
        });
        this.canvas.add(this.textObject);
        this.textObject.enterEditing();
        this.textObject.hiddenTextarea.focus();
    }
    initEvent() {
        let eventType = ["line", "circle", "rect", "triangle", "text"];
        this.canvas.on("mouse:down", options => {
            this.addDraw = true;
            if (eventType.indexOf(this.currentType) != -1) {
                this.mouseFrom.x = options.e.clientX;
                this.mouseFrom.y = options.e.clientY - 50;
                this.isDrawing = true;
                switch (this.currentType) {
                    case "text":
                        this.initText();
                        break;
                    default:
                        break;
                }
            }
        });

        this.canvas.on("mouse:move", options => {
            if (this.isDrawing && eventType.indexOf(this.currentType) != -1) {
                this.mouseTo.x = options.e.clientX;
                this.mouseTo.y = options.e.clientY - 50;
                switch (this.currentType) {
                    case "line":
                        this.ininLine();
                        break;
                    case "circle":
                        this.initCircle();
                        break;
                    case "rect":
                        this.initRect();
                        break;
                    case "triangle":
                        this.initTriangle();
                        break;

                    default:
                        break;
                }
            }
        });
        this.canvas.on("mouse:up", options => {
            this.history = this.canvas.getObjects();

            this.oldHistory = [];
            this.selectIconIndex = -1;

            if (eventType.indexOf(this.currentType) != -1) {
                this.mouseTo.x = options.e.clientX;
                this.mouseTo.y = options.e.clientY - 50;
                this.drawingObject = null;
                this.isDrawing = false;
                this.resetMove();
            }
        });


    }

    changeWidth(index, item, type) {
        if (type == "draw") {
            this.lineWidth = item.width;
            this.canvas.freeDrawingBrush.width = parseInt(this.lineWidth, 10);
            this.strokeWidth = parseInt(this.lineWidth, 10);
        } else {
            this.eraseWidth = item.width;
            this.canvas.freeDrawingBrush.width = parseInt(this.eraseWidth, 10);
            this.strokeWidth = parseInt(this.eraseWidth, 10);
        }
    }
    changeAction(type) {
        this.deselect()
        this.menuActive = type
        switch (type) {
            case 1:
                var pencil = new fabric.PencilBrush(this.canvas);
                // 设置画笔的样式
                pencil.color = this.activeColor; // 画笔颜色
                pencil.width = this.lineWidth; // 画笔宽度
                this.canvas.freeDrawingBrush = pencil;
                this.freeDraw();
                break;
            case 2:
                this.eraseDraw();
                break;
            case 3:
                this.selectDraw();
                break;
            default:
                break;
        }
    }
    changeColor(color) {
        this.activeColor = color;
        this.canvas.freeDrawingBrush.color = this.activeColor;
    }
    updateValue(val) {
        this.activeColor = val.hex;
        this.canvas.freeDrawingBrush.color = this.activeColor;
    }

    freeDraw() {
        this.removeTextObject();
        this.canvas.isDrawingMode = true;
        // this.canvas.freeDrawingBrush.strokeLineCap = 'round'; // 圆形线帽
        // this.canvas.freeDrawingBrush.strokeLineJoin = 'round'; // 圆形连接
        // this.canvas.freeDrawingBrush.decimate = 0; // 不降采样
        this.currentType = "free";
    }

    lineDraw() {
        this.currentType = "line";
        this.ininLine();
    }
    circleDraw() {
        this.currentType = "circle";
        this.initCircle();
    }
    rectDraw() {
        this.currentType = "rect";
        this.initRect();
    }
    triangleDraw() {
        this.currentType = "triangle";
        this.initTriangle();
    }
    textDraw() {
        this.currentType = "text";
        this.canvas.isDrawingMode = false;
        this.canvas.selection = false;
        if (this.drawingObject) {
            this.canvas.remove(this.drawingObject);
        }
    }
    imgDraw() {
        document.getElementById("uploadfile").click();
    }
    uploadFile(e) {
        this.canvas.isDrawingMode = false;
        this.removeTextObject();
        var file = e.target.files[0];
        var reader = new FileReader();
        reader.onload = e => {
            var data = e.target.result;
            fabric.Image.fromURL(data, img => {
                this.canvas
                    .add(
                        img.set({
                            erasable: false // 不允许擦拭
                        })
                    )
                    .renderAll();
            });
        };
        reader.readAsDataURL(file);
        e.target.value = "";
    }

    toggleDrawingObject(canvasObject) {
        this.canvas.isDrawingMode = false;
        this.canvas.selection = false;
        canvasObject.selectable = false;
        if (this.drawingObject) {
            this.canvas.remove(this.drawingObject);
        }
        this.canvas.add(canvasObject);
        this.drawingObject = canvasObject;

        if (this.textObject) {
            this.textObject.exitEditing();
            this.textObject = null;
        }
    }

    removeModel() {
        console.log('removeModel')
        let history = this.canvas.getObjects()
        for (let i = 0; i < history.length; i++) {
            if (history[i].type == "image") {
                console.log('removeModel', history[i])
                this.canvas.remove(history[i])
                // break;
            }
        }
    }

    deleteIcon() {
        this.removeModel()
        this.canvas.renderAll();
        this.drawImg(this.changeIconActiveData.item, this.changeIconActiveData.index)
    }

    deselect() {
        var history = this.canvas.getObjects()
        for (var i = 0; i < history.length; i++) {
            if (history[i].type == "image") {
                history[i].set('active', false);
                history[i].set('selectable', true); // 可选，确保对象仍然可选中
                this.canvas.discardActiveObject();
                this.canvas.renderAll();
                break;
            }
        }
    }

    eraseDraw() {
        this.currentType = "eraser";
        this.canvas.isDrawingMode = true;
        this.canvas.freeDrawingBrush = new fabric.EraserBrush(this.canvas);
        this.canvas.freeDrawingBrush.width = this.eraseWidth;
    }

    resetMove() {
        this.mouseFrom = {};
        this.mouseTo = {};
    }

    removeTextObject() {
        this.currentType = null;
        if (this.textObject) {
            this.textObject.exitEditing();
            this.textObject = null;
        }
    }
    clear() {
        this.redoDisabled = true;
        this.undoDisabled = true;
        this.resetShow = false;
        this.canvas.clear();
        this.resetMove();
        this.history = [];
        this.oldIconPosition = null;
        this.undoHistory = []
        this.redoHistory = []
        this.templateObj = null
        this.isErasing = false
    }

    exportCanvas() {
        const dataURL = this.canvas.toDataURL({
            width: this.canvas.width,
            height: this.canvas.height,
            left: 0,
            top: 0,
            format: "png"
        });
        const link = document.createElement("a");
        link.download = "canvas.png";
        link.href = dataURL;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    selectDraw() {
        if (this.menuActive != 3) {
            this.canvas.renderAll()
            return
        }
        this.canvas.isDrawingMode = false;

        this.removeTextObject();

        var history = this.canvas.getObjects();
        history.forEach(item => {
            if (item.type == "image") {
                item.set("selectable", true);
                this.canvas.setActiveObject(item);
            } else {
                item.set("selectable", false);
            }
        });
        this.canvas.renderAll()
    }

    unselectDraw() {
        this.removeTextObject();
        this.canvas.forEachObject(function (obj) {
            obj.set('active', false);
        });
        this.canvas.discardActiveObject();
        this.canvas.requestRenderAll();
    }

    drawImg(item, index) {
        this.iconIndex = index;
        EventBus.$emit('changeIconActive', this.iconIndex)
        this.history = this.canvas.getObjects();
        this.oldHistory = this.history;
        this.selectIconIndex = index;
        fabric.Image.fromURL(item, img => {
            const imgScale = 160 / img.width
            // 当前的缩放比例
            const zoom = this.canvas.getZoom();

            var left = (this.canvas.width / 2) / zoom
            var top = (this.canvas.height / 2) / zoom

            // 将图片添加到画布中
            this.canvas.add(
                img.set({
                    top,
                    left,
                    scaleX: imgScale,
                    scaleY: imgScale,
                    erasable: false, // 不允许擦拭
                    originX: 'center', // 设置图形的原点 X 轴为中心
                    originY: 'center', // 设置图形的原点 Y 轴为中心
                    centeredRotation: true, // 设置旋转时围绕中心点
                    minScaleLimit: 0.08,
                    // flipX: false,
                    // flipY: false
                    lockScalingFlip: true
                })
            );
            var history = this.canvas.getObjects()
            var obj = history[history.length - 1]
            this.canvas.setActiveObject(obj);

            this.oldIconPosition = {
                top: obj.top.toFixed(2),
                left: obj.left.toFixed(2),
                width: obj.width.toFixed(2),
                height: obj.height.toFixed(2),
                scaleX: obj.scaleX.toFixed(2),
                scaleY: obj.scaleY.toFixed(2),
                angle: obj.angle || 0,
                flipX: obj.flipX || false,

            }
            this.history = history
        });
        Gio.track({
            ClickButton_var: "模板选择栏",
            ReportedInfo_var: "模板类型",
            RequestValue_var: index + 1
        })
        setTimeout(() => {
            this.addLoad = false
        }, 200)
    }
    toDataURL() {
        return this.canvas.toDataURL({
            width: this.canvas.width,
            height: this.canvas.height,
            left: 0,
            top: 0,
            format: "png",
            quality: 1
        });
    }
    checkIfErased() {
        // 1. 获取 canvas 画布标签
        const canvas = document.getElementById('myCanvas')
        // 2. 获取 context 画笔对象
        var zoom = canvas.width / this.canvas.width
        console.log(this.canvas.width, canvas.width, canvas.height)
        let width = canvas.width
        let height = canvas.height

        const imageData = canvas.getContext('2d')
            .getImageData(0, 0, canvas.width, canvas.height);

        const data = imageData.data;

        let minX = width, minY = height;
        let maxX = 0, maxY = 0;
        let hasNonErasedPixels = false;
        // console.log('checkIfErased-data', data.length)
        for (let i = 0; i < data.length; i += 4) {
            const alpha = data[i + 3];
            if (alpha > 3) { // Assuming alpha > 0 means the pixel is not fully erased
                const x = Math.floor(i / 4) % width;
                const y = Math.floor(i / (4 * width));

                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;

                hasNonErasedPixels = true;
            }
        }

        if (hasNonErasedPixels) {
            console.log(`Unerased area: (${minX}, ${minY}) - (${maxX}, ${maxY})`)
            return {
                left: minX / zoom,
                top: minY / zoom,
                width: (maxX - minX) / zoom,
                height: (maxY - minY) / zoom
            }
        } else {
            console.log('Canvas is completely erased.')
            return {
                left: 0,
                top: 0,
                width: 0,
                height: 0,
                isCompletelyErased: true
            }
        }
    }
    getDrawSize() {
        var history = this.canvas.getObjects();
        // var isModel = false
        if (history.length) {
            // for (let i = 0; i < history.length; i++) {
            //     if (history[i].type == "image") {
            //         isModel = true
            //         break;
            //     }
            // }
            if (this.isErasing) {
                return this.checkIfErased()
            } else {
                return this.getCanvasSize(history)
            }
        } else {
            Vue.prototype.$Message.message('请先绘制')
            return {
                left: 0,
                top: 0,
                width: 0,
                height: 0,
                isCompletelyErased: true
            }
        }
    }

    getCanvasSize(history) {
        var minXBl = Infinity;
        var minYBl = -Infinity;
        var maxXBr = -Infinity;
        var maxYBr = -Infinity;
        var minXtl = Infinity;
        var minYtl = Infinity;
        var maxXtr = -Infinity;
        var minYtr = Infinity;

        for (var i = 0; i < history.length; i++) {

            var grid = history[i].lineCoords;

            if (history[i].type == "image" && this.oldIconPosition && history[i].angle) {
                let data = history[i].getBoundingRect()
                grid = {
                    tl: {
                        x: data.left,
                        y: data.top
                    },
                    tr: {
                        x: data.left + data.width,
                        y: data.top
                    },
                    bl: {
                        x: data.left,
                        y: data.top + data.height
                    },
                    br: {
                        x: data.left + data.width,
                        y: data.top + data.height
                    }
                }
                console.log('history[i].getBoundingRect()1', grid)
            }


            // Bottom-left (bl)
            if (grid.bl.x < minXBl) minXBl = grid.bl.x;
            if (grid.bl.y > minYBl) minYBl = grid.bl.y;

            // Bottom-right (br)
            if (grid.br.x > maxXBr) maxXBr = grid.br.x;
            if (grid.br.y > maxYBr) maxYBr = grid.br.y;

            // Top-left (tl)
            if (grid.tl.x < minXtl) minXtl = grid.tl.x;
            if (grid.tl.y < minYtl) minYtl = grid.tl.y;

            // Top-right (tr)
            if (grid.tr.x > maxXtr) maxXtr = grid.tr.x;
            if (grid.tr.y < minYtr) minYtr = grid.tr.y;
        }

        // Create the data object
        var data = {
            bl: { x: minXBl, y: minYBl },
            br: { x: maxXBr, y: maxYBr },
            tl: { x: minXtl, y: minYtl },
            tr: { x: maxXtr, y: minYtr }
        };

        var tlX = data.tl.x < 0 ? 0 : data.tl.x > this.canvas.width ? this.canvas.width : data.tl.x;
        var tlY = data.tl.y < 0 ? 0 : data.tl.y > this.canvas.height ? this.canvas.height : data.tl.y;

        var brX = data.br.x > this.canvas.width ? this.canvas.width : data.br.x < 0 ? 0 : data.br.x;
        var brY =
            data.bl.y > this.canvas.height ? this.canvas.height : data.bl.y < 0 ? 0 : data.bl.y;
        var width = Math.abs(brX - tlX);
        var height = Math.abs(brY - tlY);

        return {
            left: Math.min(tlX, brX),
            top: Math.min(tlY, brY),
            width,
            height
        }
    }

    getCanvasObj() {
        return this.canvas
    }

    destroyed() {

    }
}